export default function putScript(src){
    const script = document.createElement("script");
    script.src = src
    script.async = true;
    document.body.appendChild(script);
}